<script>
  import { format } from 'svelte-i18n';
  import { Tooltip } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import { formatRate } from '@client/utils/banners';

  export let row = {};
  export let props = {};

  const id = Math.random().toString(36).substring(2, 15);
  $: cached =
    props.cache &&
    props.cache[
      `${row._id}${new Date(props.filters.dateRange.startDate).getTime()}${new Date(props.filters.dateRange.endDate).getTime()}`
    ];
  $: value = cached?.metrics?.totals[props.which];
  $: hasDisableViews = row.disableviews;
</script>

{#if props.which === 'combinedCtr'}
  {#if !Number.isFinite(value)}
    <div class="muted" id="no-ctr-{id}">
      <Icon name="alert-triangle" />
      N/A
    </div>

    <Tooltip target="no-ctr-{id}" placement="right">
      {$format('label.TOOLTIP.NO_CTR')}
    </Tooltip>
  {:else}
    {formatRate(value)}
  {/if}
{:else if props.which === 'combinedCtrr'}
  {formatRate(value)}
{:else if props.which === 'combinedViews'}
  {#if hasDisableViews}
    <div class="muted" id="disabled-views-{id}">
      <Icon name="alert-triangle" />
      {$format('label.NOT_TRACKED')}

      <Tooltip target="disabled-views-{id}" placement="right">
        {$format('label.TOOLTIP.DISABLED_VIEWS')}
      </Tooltip>
    </div>
  {:else}
    {(value ?? 0).toLocaleString()}
  {/if}
{:else}
  {(value ?? 0).toLocaleString()}
{/if}

<style>
  .muted {
    align-items: center;
    border: 1px solid var(--border-color);
    border-radius: var(--border-radius-base);
    cursor: help;
    display: inline-flex;
    font-size: var(--font-size-xsmall);
    gap: 4px;
    padding: var(--padding-small) var(--padding-base);
    text-transform: uppercase;
    white-space: nowrap;
  }
</style>
